import i18n from '@dms/i18n';

import {MechanicalReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

interface NextReplacementDatePickerProps {
  name: MechanicalReplacementServiceIntervals;
}

/**
 * Date picker component for displaying the calculated next replacement date of a vehicle component.
 * This field is typically calculated automatically based on the last replacement date and replacement interval.
 * Used in service interval tracking to show when a component should be replaced next.
 *
 * @param props.name - The component name (e.g., 'engineOil', 'gearboxOil', 'timingBelt')
 */
export function NextReplacementDatePicker(props: NextReplacementDatePickerProps) {
  return (
    <Field
      type="apiDate"
      name={`serviceIntervals.${props.name}.nextReplacementDate`}
      label={i18n.t('entity.vehicle.labels.nextReplacementDate')}
    />
  );
}
